// Countdown math for the staff identification grant badge. Deadlines are
// anchored to the client clock at response time (receivedAt + ttl) so a
// skewed device clock never shows a wrong countdown.

/**
 * Why a preset member's flow fell back to the code step: no live grant
 * covered the order when it opened ('needed' — never identified, expired,
 * or bound to another order), or the server just rejected the grant with
 * 428 ('expired').
 */
export type TClubCodeHint = 'needed' | 'expired';

export const CLUB_CODE_HINT_KEYS: Record<TClubCodeHint, string> = {
  needed: 'posV2.clubIdentificationNeeded',
  expired: 'posV2.clubIdentificationExpired',
};

export function verificationDeadline(
  ttlSeconds: number,
  receivedAtMs: number
): number {
  return receivedAtMs + Math.max(ttlSeconds, 0) * 1000;
}

/** Whole seconds left before `deadlineMs`, never negative. */
export function verificationSecondsLeft(
  deadlineMs: number,
  nowMs: number
): number {
  return Math.max(Math.ceil((deadlineMs - nowMs) / 1000), 0);
}

/** 125 → "2:05". */
export function formatCountdown(seconds: number): string {
  const safe = Math.max(Math.floor(seconds), 0);
  const minutes = Math.floor(safe / 60);
  const rest = safe % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}
